//==============================================
// Navigation: Header Scroll
//==============================================


export let headerScroll = () => {

	
	// For Home Page
    if(!$('body').hasClass('home')) {

		$(document).on('scroll', function(){
				
			let winScroll = $(window).scrollTop(),
				header = $('.header'),
				headerHight = header.innerHeight();
	
			if(winScroll > (headerHight)){

				// Add active class
				header.addClass('header_scroll');

			}else{
				// Remove active class
				header.removeClass('header_scroll');
			}

		});
	}
};

export let headerInit = () =>{

	const docScroll = $(window).scrollTop(),
		header = $('.header'),
		docBody = $('body'),
		initBG = $('#section-intro .section-background');

	let delay = (docScroll < 1 && docBody.hasClass('home'))? 4000 : 0;

	setTimeout(() => {
		
		gsap.to(header, {opacity: 1, duration: 1.5, ease: 'power1.InOut'});

		gsap.to(initBG, {scale: 1, duration: 5, ease: 'power1.InOut'} );

	}, delay);

		

};